import React from 'react';

import { BrowserIcon } from 'entities/home';
import { useTranslation } from 'react-i18next';
import { DEFAULT_MAX_BUDGET, DEFAULT_MAX_DEPOSIT } from 'shared/constants';
import { useRouteChangeHandler } from 'shared/hooks';

import { CommercialArea } from '../types';
import { LocationCard } from './LocationCard';

const locations: Array<{ area: CommercialArea; labelKey: string; subtitleKey: string }> = [
  { area: CommercialArea.GWANAK, labelKey: 'locations.gwanak', subtitleKey: 'locations.gwanakSubtitle' },
  { area: CommercialArea.HONGDAE, labelKey: 'locations.hongdae', subtitleKey: 'locations.hongdaeSubtitle' },
  { area: CommercialArea.DONGDAEMUN, labelKey: 'locations.dongdaemun', subtitleKey: 'locations.dongdaemunSubtitle' },
  { area: CommercialArea.GANGNAM, labelKey: 'locations.gangnam', subtitleKey: 'locations.gangnamSubtitle' },
  { area: CommercialArea.HYEHWA, labelKey: 'locations.hyehwa', subtitleKey: 'locations.hyehwaSubtitle' },
  { area: CommercialArea.SEONGSU, labelKey: 'locations.seongsu', subtitleKey: 'locations.seongsuSubtitle' },
];

const PopularLocations = () => {
  const { t } = useTranslation('home');
  const { handleRouteChange } = useRouteChangeHandler();

  const handleLocationClick = (area: CommercialArea, label: string) => {
    window.dataLayer?.push({
      event: 'click_main',
      menu: 'location_card',
      section: 'Popular Locations',
      location: area,
    });

    const params = new URLSearchParams();
    params.append('originalWhere', label);
    params.append('whereType', 'COMMERCIAL_AREA');
    params.append('whereValue', area);
    params.append('isViewAll', 'true');
    params.append('maxDeposit', DEFAULT_MAX_DEPOSIT.toString());
    params.append('minDeposit', '0');
    params.append('maxBudget', DEFAULT_MAX_BUDGET.toString());
    params.append('minBudget', '0');
    params.append('source', 'popular_area');

    handleRouteChange(`/listing?${params.toString()}`);
  };

  return (
    <div className="flex flex-col items-start gap-y-4 max-md:w-full md:gap-y-6">
      <div className="flex items-center gap-x-2 text-white">
        <span className="flex items-center gap-x-2 text-[13px] font-medium md:text-[16px]">
          <BrowserIcon /> {t('browseByPopularLocations')}
        </span>
      </div>

      <div className="grid w-full grid-cols-3 gap-2 md:gap-4">
        {locations.map(({ area, labelKey, subtitleKey }) => (
          <LocationCard
            key={area}
            label={t(labelKey)}
            subtitle={t(subtitleKey)}
            onClick={() => handleLocationClick(area, t(labelKey))}
          />
        ))}
      </div>
    </div>
  );
};

export default PopularLocations;
